
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { Login, LoginValidObj } from '../../types/user'

@Component({
  name: 'Login'
})
export default class extends Vue {
  private loginForm = {
    loginId: '',
    password: ''
  }

  private loading = false
  private errText = ''
  private errNum = 0
  private loginRules = {
    loginId: [
      { required: true, message: '请输入账号' }
    ],
    password: [
      { required: true, message: '请输入密码' }
    ],
    verifyCode: [
      { required: true, message: '请输入验证码' }
    ]
  }

  private verifyCode = this.$apis.user.getVerifyCode + '?d=' + Number(new Date())

  $refs!: {
    loginModule: ElForm;
  }

  created () {
    this.getCustomer()
  }

  getCustomer () {
    const customerIndex = window.location.host.indexOf('gintell.cn')
    if (customerIndex !== -1) {
      window.sessionStorage.setItem('customer', window.location.host.split('.')[0])
    } else {
      window.sessionStorage.setItem('customer', 'zuhu')
    }
  }

  verifyCodeUpdate () {
    this.verifyCode = this.$apis.user.getVerifyCode + '?d=' + Number(new Date())
  }

  login () {
    this.loading = true
    this.$axios.post<Login>(this.$apis.user.login, this.loginForm).then(res => {
      this.errText = ''
      window.sessionStorage.setItem('token', res.token)
      window.sessionStorage.setItem('userInfo', JSON.stringify(res.user))
      this.$store.commit('updateUserInfo', res.user)
      this.$router.replace('/')
    }).catch((err) => {
      this.errText = err.message
      this.errNum++
      this.verifyCodeUpdate()
    }).finally(() => {
      this.loading = false
    })
  }

  handleLogin () {
    this.$refs.loginModule.validate((valid: boolean, obj: LoginValidObj) => {
      if (valid) {
        this.login()
      } else {
        this.errText = obj.loginId ? obj.loginId[0].message
          : obj.password ? obj.password[0].message
            : obj.verifyCode ? obj.verifyCode[0].message : ''
      }
    })
  }
}
